import React from "react";
import classNames from "classnames";
import { Card, CardProps } from "Components/Card";
import { HealthAndSafetyBadge } from "Components/HealthAndSafetyBadge";
import { RatingBadge } from "Components/Rating";
import { BookingMethod, VenueModel, VenueSearchResult } from "Services/API/API";
import { ImageSwiper } from "Components/ImageSwiper";
import { InstantBookBadge } from "Components/InstantBookBadge";
import Workspaces from "./Workspaces";

export interface VenueCardProps<T extends VenueSearchResult | VenueModel> extends Omit<CardProps, "onClick">  {
   venue: T,
   noSpaces?: boolean,
   className?: string,
   onClick?: (e: React.SyntheticEvent, venue: T) => void
}

export const VenueCard = <T extends VenueSearchResult | VenueModel,>({ children, venue, noSpaces, className, onClick, ...rest }: VenueCardProps<T>) => {
   /* const [setInViewElement, isVisible] = useInView({
      initialInView: false,
      rootMargin: "50px"
   }); */
   const isVisible = true;
   const hasHealthAndSafetyPolicy = venue instanceof VenueSearchResult ? venue.hasHealthAndSafetyPolicy
   : venue.healthAndSafetyPolicy;

   return (<Card className={classNames("venue-card", className, { "venue-card--invisible": !isVisible })} onClick={(e) => onClick && onClick(e, venue)} /* ref={setInViewElement}  */{...rest}>
      {
         isVisible
            ? <>
               <div className="venue-card-image">
                  <div className="venue-card-badges">
                     <div className="venue-card-badges-block">
                        {hasHealthAndSafetyPolicy && <HealthAndSafetyBadge />}
                        {venue.defaultBookingMethodHourly == BookingMethod.BookItNow && <InstantBookBadge />}
                     </div>
                     <div className="venue-card-badges-block">
                        <RatingBadge averageRating={venue.averageRating} ratingCount={venue.ratingCount} />
                     </div>
                  </div>
                  <div>{children}</div>
                  <ImageSwiper imageUrls={venue.imageUrls || []} inCard />
               </div>
               <div className="venue-card-content">
                  <div className="venue-card-name" title={venue.name}>{venue.name}</div>
                  <div className="venue-card-address" title={venue.address}>{venue.address}</div>
               </div>
               {!noSpaces && venue instanceof VenueSearchResult && <Workspaces venue={venue} />}
            </>
            : null
      }
   </Card>);
}
